import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

interface FirstTimeRegistrationProps {
  linkTo?: string;
}

export const FirstTimeRegistration = ({
  linkTo = '#',
}: FirstTimeRegistrationProps) => {
  const { t } = useTranslation();
  return (
    <section className="l-card">
      <h2 className="l-card__title">{t('login.firstTimeTitle')}</h2>
      <div className="l-card__body">
        <Link
          to={linkTo}
          className="link-button link-button--signup-first"
        >
          {t('login.firstTimeButton')}
        </Link>
      </div>
    </section>
  );
};
